import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { AlternativeRegionNamesSubmission } from "../../shared/interfaces/AlternativeRegionNames";

export function useAlternativeRegionNamesUpdate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["updateAlternativeRegionNames"],
    mutationFn: async (altRegionNames: AlternativeRegionNamesSubmission) =>
      apiContext.customerApis.updateAlternativeRegionNames(altRegionNames),
  });
}
